/*
 * @Author: Shusheng
 * @Date: 2024-08-18 10:29:23
 * @LastEditors: Shusheng
 * @Description: 全局配置
 */
import { isXwsy, isXwx, isXwyk } from '../env';
const XwxConfig = {
  logoImg: 'https://m.xiwang.com/resource/__private__/2ec43bd9ca2dde2bce7452f0f9f92558/twslogo.png',
  stopServeImg: 'https://m.xiwang.com/resource/KeHZ6GL631Z-LBPwCgf_a-1685620718907.jpg',
  favicon: 'https://m.xiwang.com/resource/__private__/2ec43bd9ca2dde2bce7452f0f9f92558/teacherdesk/favicon-xwx.ico',
  rankingGenerateViewTopBg: 'https://m.xiwang.com/resource/__private__/e237055298ca6a7bfeb881b0633f07f6/TA_image/xwx-bg.png',
  stuType: '希望学新学员'
};

const XwsyConfig = {
  logoImg: 'https://m.xiwang.com/resource/__private__/2ec43bd9ca2dde2bce7452f0f9f92558/teacherdesk/twssylogo.png',
  stopServeImg: 'https://m.xiwang.com/resource/KeHZ6GL631Z-LBPwCgf_a-1685620718907.jpg',
  favicon: 'https://m.xiwang.com/resource/__private__/2ec43bd9ca2dde2bce7452f0f9f92558/teacherdesk/favicon_sy.ico',
  rankingGenerateViewTopBg: 'https://m.xiwang.com/resource/__private__/e237055298ca6a7bfeb881b0633f07f6/TA_image/xwx-bg.png',
  stuType: '素养新学员'
};

const XwykConfig = {
  logoImg: 'https://file.wen-su.com/resource/__private__/2ec43bd9ca2dde2bce7452f0f9f92558/xwyklogo.png',
  stopServeImg: 'https://file.wen-su.com/resource/KeHZ6GL631Z-LBPwCgf_a-1685620718907.jpg',
  favicon: 'https://m.xiwang.com/resource/__private__/e237055298ca6a7bfeb881b0633f07f6/favicon.ico',
  rankingGenerateViewTopBg: 'https://m.xiwang.com/resource/__private__/e237055298ca6a7bfeb881b0633f07f6/TA_image/yk-bg.png',
  stuType: '优课新学员'
};

const getConfig = () => {
  if (isXwx) {
    return XwxConfig;
  }
  if (isXwsy) {
    return XwsyConfig;
  }
  if (isXwyk) {
    return XwykConfig;
  }
  return XwxConfig;
};

export const brandGlobalConfig = getConfig();
